import { Link } from 'react-router';

import { styled } from 'styled-components';

import { Paragraph, SectionTitle } from '../styles/text';
import { media } from '../themes/signup';
import { CircleArrowIcon } from './Icons';

enum CardSize {
  short = '160px',
  tall = '332px',
}

interface CardProps {
  title: string;
  description: string;
  background: string;
  href?: string;
  ariaLabel: string;
  onClick?: () => void;
  size?: 'short' | 'tall';
  backgroundPosition?: string;
}

interface CardContainerProps {
  $bg: string;
  $height: CardSize;
  $bgPosition?: string;
}

const CardContainer = styled.div<CardContainerProps>(
  ({ $bg, $height, $bgPosition = 'center' }) => `
  display: flex;
  justify-content: space-between;
  padding: ${$height === CardSize.tall ? '190px 24px 0px' : '40px 24px'};
  width: 100%;
  min-width: 300px;
  min-height: ${$height};
  border-radius: 8px;
  margin: 8px 0;
  transition: box-shadow 0.3s ease-in-out;
  background: ${$bg};
  background-size: cover;
  background-position: ${$bgPosition};
  `,
);

const CardContent = styled.div`
  width: 76%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.large`
    width: 100%;
  `}
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`;

export const Card = ({
  title,
  description,
  background,
  href,
  ariaLabel,
  onClick,
  size = 'short',
  backgroundPosition,
}: CardProps) => {
  const height = CardSize[size];

  const content = (
    <CardContent>
      <SectionTitle $fontSize="xlarge" $lineHeight="110%">
        {title}
      </SectionTitle>
      <Paragraph $lineHeight="140%" $fontSize="small">
        {description}
      </Paragraph>
    </CardContent>
  );

  if (onClick && href) {
    return (
      <StyledLink to={href} onClick={onClick} aria-label={ariaLabel}>
        <CardContainer $bg={background} $height={height} $bgPosition={backgroundPosition}>
          {content}
          <IconContainer>
            <CircleArrowIcon />
          </IconContainer>
        </CardContainer>
      </StyledLink>
    );
  }

  return (
    <CardContainer $bg={background} $height={height}>
      {content}
    </CardContainer>
  );
};
